import React from 'react';
import {
    Linking, Pressable, Text, useWindowDimensions, View,
} from 'react-native';
import { useIntl } from 'react-intl';
import Logo from 'src/assets/logo.png';
import { useNavigation } from '@react-navigation/native';
import { getUser } from 'speed-js-react';
import { useSelector } from 'react-redux';
import styles from './FooterStyles';
import {
    COOOLTV_FAQ,
    COOOLTV_SUPPORTED_DEVICES,
    COOOLTV_TV_PROGRAMS, HOME_SCREEN,
    MYCOOOLBOX_GENERAL_TERMS_URL,
    MYCOOOLBOX_PRIVACY_URL,
    MANUAL_COOKIES_URL,
} from '../../navigation/constants';
import { navigateWithoutHistory } from '../../navigation/Stack';

const Footer = () => {
    const { formatMessage } = useIntl();
    const { width } = useWindowDimensions();
    const navigation = useNavigation();
    const user = useSelector(getUser);

    return (
        <>
            <View style={width >= 960 ? styles.wrapper : styles.wrapper_phone}>
                <View style={width >= 960 ? styles.col_styles : styles.col_styles_phone}>
                    <Pressable
                        onPress={() => {
                            Linking.openURL(COOOLTV_TV_PROGRAMS);
                        }}
                        style={styles.pressable_styles}
                    >
                        <Text style={styles.main_link_text_styles}>
                            {formatMessage({
                                id: 'tv_programs',
                                defaultMessage:
                                'TV Programs',
                            })}
                        </Text>
                    </Pressable>
                    <Pressable
                        onPress={() => {
                            Linking.openURL(COOOLTV_SUPPORTED_DEVICES);
                        }}
                        style={styles.pressable_styles}
                    >
                        <Text style={styles.main_link_text_styles}>
                            {formatMessage({
                                id: 'supported_devices',
                                defaultMessage:
                                    'Supported devices',
                            })}
                        </Text>
                    </Pressable>
                    <Pressable
                        onPress={() => {
                            Linking.openURL(COOOLTV_FAQ);
                        }}
                    >
                        <Text style={styles.main_link_text_styles}>
                            {formatMessage({
                                id: 'faq',
                                defaultMessage:
                                    'FAQ',
                            })}
                        </Text>
                    </Pressable>
                </View>
                <View style={width >= 960 ? styles.col_styles : styles.col_styles_phone}>
                    <View>
                        <Pressable
                            onPress={() => {
                                Linking.openURL(MANUAL_COOKIES_URL);
                            }}
                            style={styles.pressable_styles}
                        >
                            <Text style={styles.main_link_text_styles}>
                                Упътване
                            </Text>
                        </Pressable>
                        <Pressable
                            onPress={() => {
                                Linking.openURL(MYCOOOLBOX_GENERAL_TERMS_URL);
                            }}
                            style={styles.pressable_styles}
                        >
                            <Text style={styles.main_link_text_styles}>
                                {formatMessage({
                                    id: 'general_terms',
                                    defaultMessage:
                                        'General Terms',
                                })}
                            </Text>
                        </Pressable>
                        <Pressable
                            onPress={() => {
                                Linking.openURL(MYCOOOLBOX_PRIVACY_URL);
                            }}
                        >
                            <Text style={styles.main_link_text_styles}>
                                {formatMessage({ id: 'privacy_policy', defaultMessage: 'Privacy policy' })}
                            </Text>
                        </Pressable>
                    </View>
                </View>
                <View style={width >= 960 ? styles.col_styles : styles.col_styles_phone}>
                    <View>
                        <Pressable
                            onPress={() => {
                                if (user) {
                                    navigateWithoutHistory(navigation, HOME_SCREEN);
                                } else {
                                    window.location.href = '/';
                                }
                            }}
                        >
                            {/* eslint-disable-next-line react-native/no-inline-styles */}
                            <img src={Logo} style={{ width: 158 }} alt="coool.tv" />
                        </Pressable>
                    </View>
                </View>
            </View>
            <View style={width >= 960 ? styles.bottomBar : styles.bottomBarMobile}>
                <View style={width >= 960 ? styles.bottomColumn : styles.bottomColumnMobile}>
                    <Text style={width >= 960 ? styles.bottomBarText : styles.bottomBarTextMobile}>
                        ©
                        {' '}
                        {(new Date()).getFullYear()}
                        {' '}
                        Cooolbox
                    </Text>
                </View>
                <View style={width >= 960 ? styles.bottomColumnIcons : styles.bottomColumnIconsMobile}>
                    <style>
                        {`
                        .footer-menu {
                            list-style: none;
                            display: flex;
                            flex-direction: 'row';
                            justify-content: 'flex-end';
                            margin: 0px;
                            padding: 0px;
                        }
                        .footer-menu li {
                            cursor: pointer;
                            display: block;
                            position: relative;
                            padding: 10px 0;
                        }
                        .footer-menu > li:not(:last-of-type) {
                            margin-right: 20px;
                        }
                        .fa-instagram {
                            width: 16px !important;
                            content: url("/wp-content/uploads/2022/11/instagram.svg");
                        }
    
                        .fa-facebook-square {
                            width: 16px !important;
                            content: url("/wp-content/uploads/2022/11/facebook.svg");
                        }
    
                        .fa-linkedin-square {
                            width: 16px !important;
                            content: url("/wp-content/uploads/2022/11/linkedin.svg");
                        }
                        .fa-twitter-square {
                            width: 16px !important;
                            content: url("/wp-content/uploads/2023/01/twitter.svg");
                        }
                        `}
                    </style>
                    <ul id="footer-menu" className="footer-menu nav-ul">
                        <li>
                            <a href="https://twitter.com/cooolboxbg">
                                <i className="obfx-menu-icon fa fa-twitter-square" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/cooolbox/">
                                <i className="obfx-menu-icon fa fa-linkedin-square" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/cooolbox.bg/">
                                <i className="obfx-menu-icon fa fa-instagram" />
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/cooolbox">
                                <i className="obfx-menu-icon fa fa-facebook-square" />
                            </a>
                        </li>
                    </ul>
                </View>
            </View>
        </>
    );
};

export default Footer;
